/**
 * Strips common suffixes to avoid spurious mismatches.
 */
export function normalizeSubstring(substring) {
    return substring
        .replace(/[.,]/gi, "") // for Inc., etc
        .toLowerCase()
        .trim()
        .split(" ")
        .filter((word) => !commonSuffixes.has(word))
        .join(" ");
}
/**
 * This list was generated by getTopRepeatedSuffixes **then** it was updated by
 * hand in order to:
 *
 * 1) exclude proper names like Amphenol
 * 2) add common suffixes from Flux's semi_conductor_manufacturers
 */
export const commonSuffixes = new Set([
    "america",
    "automation",
    "communications",
    "company",
    "components",
    "connectivity",
    "controls",
    "corp.",
    "corporation",
    "devices",
    "electric",
    "electronics",
    "enclosures",
    "engineering",
    "gmbh",
    "group",
    "icc",
    "inc.",
    "inc.",
    "industries",
    "instruments",
    "international",
    "llc",
    "ltd",
    "labs",
    "limited",
    "ltd",
    "ltd.",
    "manufacturing",
    "power",
    "products",
    "rf",
    "relays",
    "semiconductor",
    "semiconductors",
    "sensors",
    "solutions",
    "switches",
    "systems",
    "tech",
    "technologies",
    "technology",
    "tools",
    "usa",
    "wireless",
    // added manually below this line according to popular in strings semi_conductor_manufacturers
    "ag",
    "co",
    "corp",
    "inc",
    "nv",
]);
//# sourceMappingURL=normalize.js.map